export var StepContentIssueEnum;
(function (StepContentIssueEnum) {
    StepContentIssueEnum["MISSING_VARIABLE_IN_PAYLOAD"] = "MISSING_VARIABLE_IN_PAYLOAD";
    StepContentIssueEnum["ILLEGAL_VARIABLE_IN_CONTROL_VALUE"] = "ILLEGAL_VARIABLE_IN_CONTROL_VALUE";
    StepContentIssueEnum["MISSING_VALUE"] = "MISSING_VALUE";
    StepContentIssueEnum["MIN_VALUE"] = "MIN_VALUE";
    StepContentIssueEnum["INVALID_URL"] = "INVALID_URL";
    StepContentIssueEnum["TIER_LIMIT_EXCEEDED"] = "TIER_LIMIT_EXCEEDED";
})(StepContentIssueEnum || (StepContentIssueEnum = {}));
export var StepIssueEnum;
(function (StepIssueEnum) {
    StepIssueEnum["STEP_ID_EXISTS"] = "STEP_ID_EXISTS";
    StepIssueEnum["MISSING_REQUIRED_VALUE"] = "MISSING_REQUIRED_VALUE";
})(StepIssueEnum || (StepIssueEnum = {}));
